<template>
  <div class="container-fluid mt-5">
    <router-link class="float-right" to="/">
      <i class="fas fa-chevron-left"></i> Regresar
    </router-link>

    <h2 class="text-light mb-5">
      <i class="fas fa-clipboard"></i> Reporte de Asistencia
    </h2>

    <div class="row text-light">
      <div class="col-md-2 col-6">
        <b>Fecha Inicial</b>
        <input type="date" v-model="startingDate" class="form-control" />
      </div>
      <div class="col-md-2 col-6">
        <b>Fecha Final</b>
        <input type="date" v-model="endingDate" class="form-control" />
      </div>
      <div class="col-md-6 col-6">
        <b>Grupo</b>
        <select class="form-control" v-model="selectedGroup">
          <option :value="group.id" v-for="group in groups" :key="group.id">{{ group.name }}</option>
        </select>
      </div>
      <div class="col-md-2 col-6">
        <br />
        <button @click="getAttendance()" class="btn btn-dark">
          Generar Reporte
          <i class="fas fa-chart-bar ml-2"></i>
        </button>
      </div>
    </div>

    <div class="m-3">
      <table class="table-hq table table-sm table-striped " :class="[atchecker.dates > 20 ? 'table-responsive' : '']">
        <thead class="bg-black text-light">
          <tr>
            <th
              width="60"
              class="text-center"
              style="vertical-align: middle; font-size:13px; font-weight:normal; border: solid 1px #fff;">
              Codigo</th>
            <th class="text-center"
              style="vertical-align: middle; font-size:13px; font-weight:normal; min-width:150px; border: solid 1px #fff;">
              Apellido</th>
            <th class="text-center"
              style="vertical-align: middle; font-size:13px; font-weight:normal; min-width:150px; border: solid 1px #fff;">
              Nombre</th>
            <th v-for="field in atchecker.dates" :key="field.id" width="10" style="border: solid 1px #fff;">
              <span class="vertical-th">{{ field.date.substr(0,10) }}</span>
            </th>
            <th class="text-center"
              style="vertical-align: middle; font-size:13px; font-weight:normal; border: solid 1px #fff;">
              Porcentaje</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in atchecker.attendance" :key="item.id">
            <td>{{item.student.code}}</td>
            <td>{{item.student.lastname}}</td>
            <td>{{item.student.name}}</td>
            
            <td width="10" v-for="(atDate, index) in item.dates" :key="index">
              <span style="font-weight:600" class="text-uppercase" :class="[atDate.marker == 't' ? 'text-danger' : 'text-light']">
                {{atDate.marker}}
              </span>
            </td>
            <td>
              {{getPercentage(item.dates.length, item.dates) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {  
  data() {
    return {
      url: this.$store.state.url,
      schoolId: this.$store.state.schoolId,
      selectedGroup: 0,
      groups: [],
      startingDate: null,
      endingDate: null,

      fields: [],
      students: [],
      attendanceList: [],

      atchecker: []
    };
  },
  async mounted() {
    this.startingDate = this.parseDate(new Date());
    this.endingDate = this.parseDate(new Date());
    await this.getGroups();
    this.selectedGroup = this.groups[0].id;
  },
  methods: {
    async getAttendance() {
      try {
        let data = {
          method: "post",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            startingDate: this.startingDate,
            endingDate: this.endingDate,
            groupId: this.selectedGroup
          })
        };
        let req = await fetch(this.url + "getAttendanceByGourp", data);
        if (req.ok) {
          this.atchecker = await req.json();
          console.log(this.atchecker.attendance[15])
        } else {
          this.$alert(await req.json());
        }
      } catch (error) {
        this.$alert(error, "Error", "error");
      }
    },
    async getGroups() {
      let req = await fetch(this.url + "groups/" + this.schoolId);
      this.groups = await req.json();
    },
    getPercentage(base, array){
      let percent = 0
      array.forEach(element => {
        if (element.marker) 
          percent++
      });

      percent = (percent * 100) / base

      return percent.toFixed(0) + " %"
    },
    parseDate(value) {
      let d = value.getDate();
      if (d < 10) {
        d = "0" + d;
      }
      let m = value.getMonth() + 1;
      if (m < 10) {
        m = "0" + m;
      }
      let y = value.getFullYear();
      return y + "-" + m + "-" + d;
    }
  }
};
</script>

<style>
.vertical-th {
  writing-mode: vertical-rl;
  text-orientation: mixed;
  padding: 10px 2px;
  font-size: 10px;
  height: 100px;
  text-align: center;
  font-weight: normal;
}

.table-hq td {
  border: solid 1px #333;
  text-align: center;
  font-size: 12px;
  font-style: italic;
  /* background-color: #fff; */
  border-color: #fff;
}

@media print and (orientation:landscape){
  
  table, th, td {
    color: #222 !important;
    border-color: #444 !important;
  }

  
}
</style>